export default __webpack_public_path__ + "static/media/dummy.6ebfe57b.png";